<template>
  <svg viewBox="57 23 45 35" xmlns="http://www.w3.org/2000/svg">
    <!-- <g transform="scale(3.5) translate(-55 -20)"> -->
    <g>
      <ellipse class="cls-1" cx="79.38" cy="57.23" rx="24.46" ry="11.95" />
      <ellipse class="cls-2" cx="79.38" cy="57.23" rx="18.92" ry="9.44" />
      <path
        class="cls-3"
        d="M64.23,24.67V22.91a1.29,1.29,0,0,1,1.29-1.29l16.58,0A1.29,1.29,0,0,1,83.38,23l0,7.06a1.29,1.29,0,0,0,1.27,1.31l7.53.08a1.28,1.28,0,0,1,1.27,1.29v5.74"
      />
      <path class="cls-3" d="M79.35,57H65.67a1.35,1.35,0,0,1-1.27-1.41V33.29" />
      <line class="cls-4" x1="82.91" y1="21.93" x2="92.91" y2="31.64" />
      <line class="cls-3" x1="70.07" y1="34.91" x2="78.76" y2="34.91" />
      <line class="cls-3" x1="70.07" y1="47.22" x2="78.76" y2="47.22" />
      <line class="cls-3" x1="70.07" y1="41.06" x2="78.76" y2="41.06" />
      <path
        class="cls-3"
        d="M89.7,44a6.69,6.69,0,1,1-6.63,6.69,5.06,5.06,0,0,1,0-.55"
      />
      <path
        class="cls-5"
        d="M89.34,40.62l-5,2.91a.2.2,0,0,0,0,.35l5,2.92a.21.21,0,0,0,.32-.18V40.79A.21.21,0,0,0,89.34,40.62Z"
      />
      <ellipse class="cls-5" cx="64.16" cy="28.73" rx="1.34" ry="1.36" />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
  .cls-1 {
    fill: #d5ebe9;
  }
  .cls-2 {
    fill: #b8ded9;
  }
  .cls-3 {
    fill: none;
  }
  .cls-3,
  .cls-4,
  .cls-5 {
    stroke: #1ba586;
    stroke-miterlimit: 10;
  }
  .cls-3,
  .cls-4 {
    stroke-linecap: round;
    stroke-width: 3.06px;
  }
  .cls-4,
  .cls-5 {
    fill: #1ba586;
  }
  .cls-5 {
    stroke-width: 0.74px;
  }
</style>
